<template>
<main>
  <Content>
    <section>
      <h1>legal info</h1>
      <span style="color: var(--color-error); font-weight:bold;">Ordering temporarily not available because of company changes. Until we are back, please get in touch for any inquiries. Previous terms and company info:</span>
      <br>
      <br>
      <br>
      <div style="opacity: 0.3;">
      The latest version of the general terms and the privacy policy (effective as of 2022 May 10) can be downloaded here: 
      <br>
      <br>
      <a :href="`${blobRoot}docs/cityphography_legal_20220510_HU.pdf`" target="_blank">cityphography legal documents - 20220510 [PDF] HU</a>

      <h2>terms &amp; conditions</h2>
      <p>
        This website is operated by:
        <br>Bálint István Szabó EV - sole proprietor - @thehighdynamic      
        <br>Operator is private entrepreneur in low tax-bracket enterprise. 
        <br><i>Registered office:</i> HU, 2314 Halásztelek, Csillag utca 3/18
        <br><i>Tax number:</i> 55502784-2-33
        <br><i>EU tax number:</i> HU55502784
        <br><i>Registration number:</i> 54194951
        <br><i>Email:</i> info@cityphography.com
        <br>
        <br>
        For using the site, making payments and orders, customers must accept the general terms and conditions. Please see the download link above.
      </p>
      </div>
      <h2>privacy policy</h2>
      <p>
        This website uses cookies (like almost every website these days), and may ask you for some personal information during checkout, but only to an essential extent to be able to fulfill your orders, and does not aim to track individuals.
        We know you value your privacy, and so do we.
        <br>
        <br>
        Any data collected without your explicit consent is done so by our legitimate interest, but should you have any concerns, please reach out and we will get in touch with you immediately.
        <br>
        For details about what data is collected and how it is processed, please see the download link above.
      </p>
      <h2>copyright</h2>
      <p>
        You may not reproduce or communicate any of the content on this website, including downloadable material from this website and the physical photographs in the delivered product, without the permission of the copyright owner: Bálint István Szabó - @thehighdynamic
      </p>
      
      
    </section>    
  </Content>
</main>
</template>

<script>

import Content from '@/components/Content.vue';

export default {
  name: 'Legal' ,
  components: {
    Content
  },
  data(){
    return {
      blobRoot: process.env.VUE_APP_BLOB_ROOT
    }
  },
  metaInfo() {
    return {
      title: "legal - cityphography",
      meta: [        
        { vmid: "og:title", property: "og:title", content: "legal - cityphography" },  
        { vmid: "description", name: "description", content: "Legal information about cityphography: terms and conditions, privacy policy, copyright and license info." },
        { vmid: "og:description", property: "og:description", content: "Legal information about cityphography: terms and conditions, privacy policy, copyright and license info." }        
      ],
    };
  },
}
</script>